import { TRUE } from "sass"

// 公共样式
export const commonStyle = {
    rotate: 0,
    opacity: 1,
}

export const commonAttr = {
    // animations: [],
    events: {},
    groupStyle: {}, // 当一个组件成为 Group 的子组件时使用
    isLock: false, // 是否锁定组件
}

// 编辑器左侧组件列表
const list = [
    {
        component: 'v-text',
        label: '文字',
        propValue: '双击编辑文字',
        icon: 'wenben1',
        style: {
            width: 200,
            height: 22,
            fontSize: 14,
            fontWeight: 500,
            lineHeight: '',
            letterSpacing: 0,
            textAlign: '',
            color: '',
        },
    },
    {
        component: 'v-button',
        label: '按钮',
        propValue: '按钮',
        icon: 'button',
        style: {
            width: 100,
            height: 34,
            borderWidth: 1,
            borderColor: '',
            borderRadius: '',
            fontSize: 14,
            fontWeight: 500,
            className: '',
            lineHeight: '',
            letterSpacing: 0,
            textAlign: '',
            color: '',
            backgroundColor: '',
        },
    },
    {
        component: 'Picture',
        label: '图片',
        propValue: '图片',
        icon: 'tupian1',
        style: {
            width: 300,
            height: 200,
            borderRadius: '',
            img: require('@/assets/title.jpg'),
        },
    },
    {
        component: 'v-icon',
        label: '图标',
        propValue: '图标',
        icon: 'biaotitubiao',
        style: {
            fontSize: 70,
            fontWeight: 500,
            color: '',
            className: 'wenduji-',
        },
    },
    {
        component: 'v-input',
        label: '输入框',
        propValue: '输入框',
        icon: 'danhangshurukuang',
        style: {
            width: 200,
            // height: 32,
            // fontSize: 14,
            // fontWeight: 500,
            // lineHeight: '',
            // letterSpacing: 0,
            // textAlign: '',
            // color: '',
        },
    },
    {
        component: 'rect-shape',
        label: '矩形',
        propValue: '矩形',
        icon: 'juxing',
        style: {
            width: 200,
            height: 200,
            // fontSize: 14,
            // fontWeight: 500,
            // lineHeight: '',
            // letterSpacing: 0,
            // textAlign: 'center',
            // color: '',
            borderColor: '',
            borderWidth: 0,
            backgroundColor: '#FCFCFC',
            borderStyle: 'solid',
            borderRadius: '',
            // verticalAlign: 'middle',
        },
    },
    {
        component: 'v-line',
        label: '折线图',
        propValue: '折线图',
        icon: 'tubiao-zhexiantu',
        style: {
            width: 500,
            height: 250,
            lineColor: '#5470c6',
            lineWidth: 2,
            lineItemColor: '#5470c6',
            labelShow: false,
            symbolShow: false,
            smooth: false,
            toolShow: false,
            xname: '',
            yname: '',
            sname: '',
            legendShow: false,
            borderColor: '',
            borderWidth: 0,
            borderStyle: 'solid',
            backgroundColor: '#fff',
            mode: false
        },
    },
    {
        component: 'v-bar',
        label: '柱形图',
        propValue: '柱形图',
        icon: 'icon_zhuxingtu',
        style: {
            width: 500,
            height: 250,
            barWidth: 40,
            barItemColor: '#5470c6',
            labelShow: false,
            toolShow: false,
            xname: '',
            yname: '',
            sname: '',
            legendShow: false,
            borderColor: '',
            borderWidth: 0,
            borderStyle: 'solid',
            backgroundColor: '#fff',
            mode: false
        },
    },
    {
        component: 'v-pie',
        label: '饼图',
        propValue: '饼图',
        icon: 'a-15bingtu',
        style: {
            width: 500,
            height: 250,
            labelShow: false,
            toolShow: false,
            sname: '',
            legendShow: false,
            borderColor: '',
            borderWidth: 0,
            borderStyle: 'solid',
            backgroundColor: '#fff',
            mode: false
        },
    },
    {
        component: 'v-gauge',
        label: '仪表盘',
        propValue: '仪表盘',
        icon: 'yibiaopan_o',
        style: {
            width: 500,
            height: 250,
            labelShow: false,
            toolShow: false,
            sname: '',
            legendShow: false,
            borderColor: '',
            borderWidth: 0,
            borderStyle: 'solid',
            backgroundColor: '#fff',
            mode: false
        },
    },
    { 
        component: 'LineUPG',
        label: '折线图',
        propValue: '折线图',
        icon: 'zhexiantu',
        style: {
            width: 500,
            height: 250,
            lineColor: '#5470c6',
            lineWidth: 2,
            lineItemColor: '#5470c6',
            labelShow: false,
            symbolShow: false,
            smooth: false,
            toolShow: false,
            xname: '',
            yname: '',
            sname: '',
            legendShow: false,
            borderColor: '',
            borderWidth: 0,
            borderStyle: 'solid',
            backgroundColor: '#fff',
            mode: false
        },
    },
    {
        component: 'v-sector',
        label: '扇形图',
        propValue: '扇形图',
        icon: 'shanxing',
        style: {
            width: 500,
            height: 250,
            labelShow: false,
            toolShow: false,
            sname: '',
            legendShow: false,
            borderColor: '',
            borderWidth: 0,
            borderStyle: 'solid',
            backgroundColor: '#fff',
            mode: false
        },
    },
    // {
    //     component: 'CustomOHLC',
    //     label: 'OHLC图',
    //     propValue: 'OHLC图',
    //     icon: 'shanxing',
    //     style: {
    //         width: 500,
    //         height: 250,
    //         labelShow: false,
    //         toolShow: false,
    //         sname: '',
    //         legendShow: false,
    //         borderColor: '',
    //         borderWidth: 0,
    //         borderStyle: 'solid',
    //         backgroundColor: '#fff',
    //         mode: false
    //     },
    // },
]

for (let i = 0, len = list.length; i < len; i++) {
    const item = list[i]
    item.style = { ...commonStyle, ...item.style }
    list[i] = { ...commonAttr, ...item }
}

export default list
